import type { HpMarketingAd } from '@pickleballinc/ui/types/hp-marketing-ad';
import { useQuery } from '@tanstack/react-query';

import type { AdModuleFor } from '@/utils/actions/hp-marketing/searchCardAds.core';
import { postRoute } from '@/utils/helpers/fetchRoute';

/**
 * Fetches the rotating search-card ads for a dashboard surface. Centralizes the query key, fetch,
 * and empty-array default shared by the My Gear and Play Opportunities widgets.
 */
export function useHpMarketingAd(moduleFor: AdModuleFor) {
  const { data: ads = [], isLoading } = useQuery({
    queryKey: ['dashboard-hp-marketing-ad', moduleFor],
    queryFn: async ({ signal }) => {
      const res = await postRoute<HpMarketingAd[]>(
        'hpMarketingSearchCardAds',
        { moduleFor },
        signal
      );
      return res?.data ?? [];
    },
  });

  return { ads, isLoading, hasAd: ads.length > 0 };
}
